import * as React from 'react';
import {Link, RouteComponentProps, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withStyles, WithStyles } from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import * as EventActions from '@services/events/event.action';
import cordovaContext from "src/cordovaContext";
import { BottomBarStyle } from './BottomBar.style';
import { privatRoutesPathes } from '@router/router.constants';
import { ITodo, TODO_TYPE } from '@app-types/websocket/todo.types';
import { IChat } from '@app-types/websocket/chat.types';
import { ISharedNote } from '@app-types/websocket/sharedinfo.types';
import { IFlowPost } from '@app-types/websocket/imageflow.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import { IEcoAgreement, IEcoPurchase, IEcoSplitSetting, IEcoTransfer } from '@app-types/websocket/economy.types';
import { SUGGESTION_TYPES } from '@constants/suggestionTypes';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import { ISchedule } from '@app-types/websocket/schedule.types';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import { getAgreementNotificationCount, getPurchaseBalance, getTransferBalance, getTransferBookingDate } from '@helpers/EconomyHelper';
import { ChatIcon } from '@icons/Chat';
import { HelpIcon } from '@icons/Help';
import { CalendarIcon } from '@icons/Calendar';
import { ChecklistIcon } from '@icons/Checklist';
import { MoneyIcon } from '@icons/Money';
import { BookIcon } from '@icons/Book';
import { DotsIcon } from '@icons/Dots';
import { SettingsIcon } from '@icons/Settings';
import { getSelectedFamilyResource } from '@services/user/user.utils';
import { runCordovaPluginCall } from '@helpers/cordovaBridge';
import {IEvent} from '@app-types/websocket/event.types';
import {getCalendarTodoCount} from '@components/todo/calendarTodoItems';
import {useCalendarTodoDate} from '@components/todo/useCalendarTodoDate';
import {usePackingBadgeCount} from '@components/next-handover/packingList';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends RouteComponentProps, WithStyles<typeof BottomBarStyle> {
  userId:number;
  hidden:boolean;
  displaySubmenyCallback:(isDisplayingSubmeny:boolean) => void;
  bottomTitle:string,


  calendarNotifications:number;
  kidsNotifications:number;
  chatNotifications:number;
  todoNotifications:number;
  calendarEvents:IEvent[];
  todos:ITodo[];
  schedules:ISchedule[];
  calendars:number[]|undefined;
  economyNotifications:number;
  settingsNotifications:number;
  knowledgeNotifications:number;
  
  isParent:boolean;
  inviteMem :IFamilyMember|undefined;
  isTogether:boolean;
}



interface IState {
  showSubmenu:boolean;
}

class BottomBar extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      showSubmenu:false,
    };
  }

  public updateBadgeCount( ) {
    const isCordovaApp = this.context;
    if (isCordovaApp) {
      const badgeCount =  this.props.calendarNotifications+ this.props.kidsNotifications+ this.props.chatNotifications+ 
        this.props.todoNotifications+ this.props.economyNotifications+ this.props.settingsNotifications+ this.props.knowledgeNotifications;
      const FirebasePlugin = (globalThis as any).FirebasePlugin;
      if (FirebasePlugin === undefined || FirebasePlugin === null) {
        console.warn("FirebasePlugin is undefined");
        return;
      }

      runCordovaPluginCall("FirebasePlugin.setBadgeNumber", () => {
        FirebasePlugin.setBadgeNumber(badgeCount);
      });
    }
  }

  public componentDidMount(): void {
    this.updateBadgeCount();
  }

  public componentDidUpdate(prevProps:IProps, oldState:IState) {
    this.updateBadgeCount();
  }

  public render() {
    const {classes, hidden} = this.props;

    let style:React.CSSProperties = {};
    let FABstyle:string = classes.FAB;
    if (hidden) {
      style={maxHeight:'0px', pointerEvents:'none', opacity:0}
    }
    if (hidden || !this.state.showSubmenu) {
      FABstyle=FABstyle+" "+classes.FABHidden
    }

    const atCalendar = this.props && this.props.location && 
      (this.props.location.pathname.indexOf(privatRoutesPathes.CALENDAR) > -1);
    const atKids = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.INFOBANK) > -1);
    const atChat = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.MESSAGES) > -1);
    const atTodo = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.NOTES) > -1);
    const atEconomy = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.ECONOMY) > -1);
    const atSettings = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.SETTINGS) > -1);
    const atKnowledge = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.KNOWLEDGE) > -1);

    const showMoreNotifications = this.state.showSubmenu ? 0
      : this.props.economyNotifications + this.props.settingsNotifications + this.props.knowledgeNotifications;

    const chatIcon = <ChatIcon style={{  opacity:atChat?'0.68':'0.34'}}/>
    const kidsIcon = <HelpIcon style={{ opacity:atKids?'0.68':'0.34'}}/>
    const calendarIcon = <CalendarIcon style={{ opacity:atCalendar?'0.68':'0.34'}}/>
    const todoIcon = <ChecklistIcon style={{ opacity:atTodo?'0.68':'0.34'}} />
    const economyIcon = <MoneyIcon style={{ opacity:atEconomy?'0.68':'0.34'}}/>
    const settingsIcon = <SettingsIcon style={{ opacity:atSettings?'0.68':'0.34'}}/>
    const knowledgeIcon = <BookIcon style={{ opacity:atKnowledge?'0.68':'0.34'}}/>
    const moreIcon = <DotsIcon style={{ opacity:'0.34'}}/>

    let settingsLink:string = privatRoutesPathes.SETTINGS+"/:userId";
    if (this.props.inviteMem !== undefined) {
      settingsLink = privatRoutesPathes.SETTINGS+"/"+this.props.inviteMem.id;
    }

    const chatButton = this.generateButton(chatIcon, this.props.chatNotifications, atChat, 
      privatRoutesPathes.MESSAGES+"/:chatId");
    const kidsButton = this.generateButton(kidsIcon, this.props.kidsNotifications, atKids, 
      privatRoutesPathes.INFOBANK+"/:tab");
    const calendarButton = this.generateButton(calendarIcon, this.props.calendarNotifications, atCalendar, 
      privatRoutesPathes.CALENDAR+"/:calendarId/:suggestionId");
    const todoButton = this.generateButton(todoIcon, this.props.todoNotifications, atTodo, 
      privatRoutesPathes.NOTES+"/:tab");
    const economyButton = this.generateButton(economyIcon, this.props.economyNotifications, atEconomy, 
      privatRoutesPathes.ECONOMY+"/:transactionId");
    const settingsButton = this.generateButton(settingsIcon, this.props.settingsNotifications, atSettings, settingsLink);
    const knowledgeButton = this.generateButton(knowledgeIcon, this.props.knowledgeNotifications, atKnowledge, 
      privatRoutesPathes.KNOWLEDGE);

    let showMoreIcon:JSX.Element;
    if (this.state.showSubmenu) {
      showMoreIcon = moreIcon;
    } else if (atSettings) {
      showMoreIcon = settingsIcon;
    } else if (atEconomy) {
      showMoreIcon = economyIcon;
    } else if (atKnowledge) {
      showMoreIcon = knowledgeIcon;
    } else {
      showMoreIcon = moreIcon;
    }

    const moreButton = this.generateButton(showMoreIcon, showMoreNotifications, false, undefined, ()=>{
      this.setState({showSubmenu:!this.state.showSubmenu}); 
      this.props.displaySubmenyCallback(!this.state.showSubmenu)
    })

    const isParent = this.props.isParent;

    if (this.props.isTogether) {
      return (
        <div className={classes.footer} style={style}>
          {chatButton}
          {kidsButton}
          {calendarButton}
          {todoButton}
          {settingsButton}
          <div className={classes.famName} >{this.props.bottomTitle}</div>
        </div>)
    }

    return (<>
      <div className={classes.footer} style={style}>
        {chatButton}
        {kidsButton}
        {calendarButton}
        {todoButton}
        {moreButton}
        <div className={classes.famName} >{this.props.bottomTitle}</div>
      </div>

      <div className={FABstyle} style={{bottom:this.state.showSubmenu?'100px':'20px'}}>
        {isParent?economyButton:settingsButton}
      </div>

      <div className={FABstyle} style={{bottom:this.state.showSubmenu?'182px':'20px'}}>
        {knowledgeButton}
      </div>

      {isParent && <div className={FABstyle} style={{bottom:this.state.showSubmenu?'264px':'20px'}}>
        {settingsButton}
      </div>}

      </>
    );
  }

  private generateButton(icon:JSX.Element, badgeCount:number, highLight:boolean, link:string|undefined, onClick?:() => void) {
    if (link) {
      return (
        <Link to={link} style={{textDecoration: 'none'}}>
          <div className={this.props.classes.iconButton} onClick={onClick
              ?() => onClick()
              :()=>{
                this.setState({showSubmenu:false}); 
                this.props.displaySubmenyCallback(false)
              }}>
            {icon}
            <div style={{opacity: badgeCount > 0 ? 1 : 0}} className={this.props.classes.badge}>
              {badgeCount > 0 ?badgeCount:""}</div>
          </div>
        </Link>);
    } else {
      return (
        <div className={this.props.classes.iconButton} onClick={onClick
            ?()=>onClick()
            :()=>{
              this.setState({showSubmenu:false}); 
              this.props.displaySubmenyCallback(false)
            }}>
          {icon}
          <div style={{opacity: badgeCount > 0 ? 1 : 0}} className={this.props.classes.badge}>
            {badgeCount > 0 ?badgeCount:""}</div>
        </div>);
    }
  }
}

const NO_SCHEDULES: ISchedule[] = [];

const BottomBarWithCalendarTodos = (props: IProps) => {
  const now = useCalendarTodoDate();
  const calendarCount = getCalendarTodoCount(props.calendarEvents, props.userId, now);
  const packingCount = usePackingBadgeCount(props.todos, props.schedules, props.calendars, props.userId);
  return <BottomBar {...props} todoNotifications={props.todoNotifications + calendarCount + packingCount} />;
};

function mapStateToProps(state: any) {
  const userId = state?.user?.session?.data?.id ?? 0;

  let calendarNotifications:number = 0;
  let kidsNotifications:number = 0;
  let chatNotifications:number = 0;
  let todoNotifications:number = 0;
  let economyNotifications:number = 0;
  let settingsNotifications:number = 0;
  const knowledgeNotifications:number = 0;


  const chats:IChat[] = state?.chat?.chats ? state.chat.chats : [];
  for (const chat of chats) {
    const participants = chat.participants ? chat.participants : {};
    if (chat.messages && chat.messages.length > 0 && participants[userId]) {
      chatNotifications += (Math.max(
        chat.messages[chat.messages.length - 1].id - participants[userId].lastRead, 0));
    }
  }

  const todos:ITodo[] = state?.todo?.todos ? state.todo.todos : [];
  if (todos.length > 0) {
    for (const todo of todos) {
      if (todo.type === TODO_TYPE.NORMAL && (
        (todo.seen && !todo.seen.includes(userId) && todo.completedBy === undefined) 
        || (todo.assigned && todo.assigned.includes(userId) && todo.completedBy === undefined)
      )) {
        todoNotifications++;
      }
    }
  }

  if (state?.notes?.sharedNotes) {
    for (const note of state.notes.sharedNotes as ISharedNote[]) {
      if (note.accountName === undefined && note.seenBy.indexOf(userId) === -1) {
        todoNotifications++;
      } else if (note.accountName !== undefined && note.seenBy.indexOf(userId) === -1) {
        kidsNotifications++;
      }
    }
  }

  let isTogether:boolean = false;
  const myFam = getSelectedFamilyResource(state?.user?.session);
  if (myFam !== undefined) {
      isTogether = myFam.familyType === "TOGETHER";
  }

  // Together families don't have the image flow, so their posts aren't shown anywhere
  if (!isTogether && state?.posts?.posts) {
    for (const post of state.posts.posts as IFlowPost[]) {
      if (post.seen.indexOf(userId) === -1) {
        kidsNotifications++;
      }
    }
  }

  let isParent = false;

  const family:IFamilyMember[] = state?.family?.family?state.family.family:[];
  let inviteMem :IFamilyMember|undefined;
  if (family) {
    for (const mem of family) {
      if (mem.id === userId) {
        if (mem.role === FamilyMemberType.PARENT ) {
          isParent = true;
        }
      }
    }
    if (isParent) {
      for (const mem of family) {
        if (mem.id !== userId) {
          if (mem.role === FamilyMemberType.PARENT 
            && (mem.lastOnline === undefined || mem.lastOnline <= 0) 
            && (mem.inviteTime === undefined || mem.inviteTime === 0)) {
            inviteMem = mem;
            settingsNotifications += 1;
          }
        }
      }  
    }
  }

  if (isParent) {
    const agr:IEcoAgreement[]|undefined = state?.economy?.agreements;

    let totalBalance = 0;
    let prevMonthBalance = 0;
    const monthCutoff:Date = new Date();
    monthCutoff.setHours(0, 0, 0, 0);
    monthCutoff.setDate(1);
    const cutoffTime = monthCutoff.getTime();

    let ecosettings:IEcoSplitSetting[] = state?.user?.splitSetting;

    let myPercentage = 50;
    if (ecosettings === undefined || ecosettings.length === 0) {
      ecosettings = [];
      ecosettings.push({
        start:0,
        split: family.filter((mem) => mem.role === FamilyMemberType.PARENT).map((mem) => ({accountId:mem.id, percentage:50})),
      });
    } else {
      for (const split of ecosettings[ecosettings.length -1].split) {
        if (split.accountId === userId) {
          myPercentage = split.percentage;
        }
      }
    }

    if (agr) {
      economyNotifications += getAgreementNotificationCount(agr, userId);
    }
  
    const pur:IEcoPurchase[]|undefined = state?.economy?.purchases;
  
    if (pur) {
      for (const purchase of pur) {
        if (purchase.deleted === false && !purchase.disputedBy) {
          const balance = getPurchaseBalance(purchase, userId, ecosettings);
          totalBalance += balance;
          if (purchase.date < cutoffTime) {
            prevMonthBalance += balance;
          }
        }
        if ((!purchase.deleted) && purchase.seenBy.indexOf(userId) === -1) {
          economyNotifications++;
        } else if (purchase.deleted && purchase.archivedBy.indexOf(userId) === -1) {
          economyNotifications++;
        } else if (!purchase.deleted && purchase.disputedBy !== undefined) {
          economyNotifications++;
        }
      }
    }
  
    const transfers:IEcoTransfer[]|undefined = state?.economy?.transfers;
    if (transfers) {
      for (const transfer of transfers) {
        if (transfer.deleted === false && !transfer.disputedBy) {
          const balance = getTransferBalance(transfer, userId, ecosettings);
          totalBalance += balance;
          if (getTransferBookingDate(transfer) < cutoffTime) {
              prevMonthBalance += balance;
          }
        }

        if ((!transfer.deleted) && transfer.seenBy.indexOf(userId) === -1) {
          economyNotifications++;
        } else if (transfer.deleted && transfer.archivedBy.indexOf(userId) === -1) {
          economyNotifications++;
        }
      }
    }

    if (totalBalance < -50 && prevMonthBalance < -50) {
      economyNotifications++;
    }

    const schedules:ISchedule[] = state?.schedule?.schedules?state.schedule.schedules:[];

    if (state.suggestion && state.suggestion.suggestions) {
      for (const suggestion of state.suggestion.suggestions as ISuggestion[]) {
        if (suggestion.creatorId !== userId && suggestion.status === SUGGESTION_TYPES.AWAITING_APPROVAL && suggestion.schedules.length > 0) {
          const schedule = schedules.find((s) => s.id === suggestion.schedules[0]);
          if (schedule && (schedule.status === SCHEDULE_TYPES.SHARED || schedule.status === SCHEDULE_TYPES.ACTIVE)) {
            calendarNotifications += 1;
          }
        }
      }
    }
  }

  let bottomTitle:string = "";

  const resources:any[] = Array.isArray(state?.user?.session?.data?.resources)
    ? state.user.session.data.resources
    : [];
  if (resources.length > 0) {
      if (resources.length > 1 && family) {
        bottomTitle = family.filter((m) => m.role === FamilyMemberType.PARENT).map((m) => m.firstName).join(" & ");
      }
  }

  return {
    userId,
    calendarNotifications,
    kidsNotifications,
    chatNotifications,
    todoNotifications,
    calendarEvents: state.event?.events || [],
    todos,
    schedules: state?.schedule?.schedules || NO_SCHEDULES,
    calendars: state?.user?.calendarSettings?.calendars,
    economyNotifications,
    settingsNotifications,
    knowledgeNotifications,
    inviteMem,
    isParent,
    isTogether,
    bottomTitle,
  };
}

const mapDispatchToProps = {
  seenEvent: EventActions.seenEvent,
};

BottomBar.contextType = cordovaContext;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(BottomBarStyle)(BottomBarWithCalendarTodos)));



// WEBPACK FOOTER //
// ./src/components/calendar2/fab/BottomBar.tsx